/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartUrlDto } from '../../models/part-url-dto';
import { PartUrlsRequestDto } from '../../models/part-urls-request-dto';

export interface MatchVideoControllerGetPartUrls$Params {
  uuid: string;
      body: PartUrlsRequestDto
}

export function matchVideoControllerGetPartUrls(http: HttpClient, rootUrl: string, params: MatchVideoControllerGetPartUrls$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PartUrlDto>>> {
  const rb = new RequestBuilder(rootUrl, matchVideoControllerGetPartUrls.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PartUrlDto>>;
    })
  );
}

matchVideoControllerGetPartUrls.PATH = '/match-videos/{uuid}/upload/part-urls';
